/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef } from "react";
import styles from "./LandingHeader.module.scss";
import { getCookie, deleteCookie } from "../../../utils/utils";
import { useHistory } from "react-router-dom";
import { StoreContext } from "../../../components/ContextStore/StoreContextProvider";
import { ADMIN_ROUTES, ADMIN_ROUTE_LABELS } from "../../../constants/routeConfig";
import MicroserviceFetchUtil from "../../../common/microservice-fetch-util";
import { isMobile } from "react-device-detect";
import { Tooltip } from "react-tooltip";
import imagePaths from "../../../constants/imagePaths";
import { doSSOLogout } from "../../../firebase/ssoAuthenticate";
import Select from "react-select";
import configData from "../../../common/configData.json";
import GaEventHelper from '../../../helper/ga-event-helper';
import { GA_EVENTS, GA_DATA_PARAMS } from '../../../common/gaEventConstants';
import { logoutService } from "../../../services/SessionService";
import { shouldRenderOfflineApp } from "../../../helper/FileHelper";
import CountryDropdown from "../../common/CountryDropdown/CountryDropdown";
import { isShadowUser as checkShadowUser } from "../../../helper/effectiveEmailHelper";
const LandingHeader = () => {
  const { landingHeader, common } = imagePaths;
  const { userDetails, selectedCountryCode, selectedBsa, updateSelectedBsa } =
    useContext(StoreContext);
  const [dtAccess] = useState(
    userDetails.dtAccessCodes ? userDetails.dtAccessCodes.split(",") : []
  );
  const [superUser] = useState(
    userDetails.accessToOperationalDashboards &&
    (userDetails.isSuperUser === "YES" || !dtAccess.length)
  );
  const [dtAccessToggle, setDTAccessToggle] = useState("All");
  const [menu, setMenu] = useState(false);
  const [reports, setReports] = useState(false);
  const history = useHistory();
  const handleMenu = () => {
    setMenu(!menu);
  };
  const wrapperRef = useRef(null);

  const [operationalReportsData, setOperationalReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openReportDropdown, setOpenReportDropdown] = useState("");
  const reportTypes = [
    {
      label: "Transactional Reports",
      value: "transactionalreports",
      icon: landingHeader.graphBar,
    },
    { label: "Master Reports", value: "masterreports", icon: landingHeader.gold },
  ];

  const isAdminRoute = (pathname) => {
    return ADMIN_ROUTES.includes(pathname);
  };

  const handleBsaChange = (data) => {
    updateSelectedBsa(data.label);
  };

  const isShadowUser = checkShadowUser(userDetails);
  const offlineAppCond = userDetails?.email?.endsWith("@unilever.com");
  shouldRenderOfflineApp(configData, selectedCountryCode, offlineAppCond);

  const logoutHandler = async () => {
    GaEventHelper.gaCommonEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: GA_EVENTS.logout })
    logoutService(selectedCountryCode);
    if (getCookie("isSSOLogin") || getCookie("isMFALogin")) {
      await doSSOLogout();
      getCookie("idToken") && deleteCookie("idToken");
      getCookie("refreshToken") && deleteCookie("refreshToken");
      getCookie("isSSOLogin") && deleteCookie("isSSOLogin");
      getCookie("isMFALogin") && deleteCookie("isMFALogin");
      getCookie("countryCode") && deleteCookie("countryCode")
      localStorage.removeItem("countryCode");
      localStorage.removeItem("isIndonesia");
      localStorage.removeItem("isIndonesiaIc");
      localStorage.removeItem("isVietnam");
      localStorage.removeItem("isPhilipines");
      localStorage.removeItem("isThailand");
      localStorage.removeItem("isPakistan");
      localStorage.removeItem("isBangladesh");
      localStorage.removeItem("isCambodia");
      localStorage.removeItem("isLaos");
      localStorage.removeItem("isMalaysia");
      localStorage.removeItem("adminAccess");
      localStorage.removeItem("selectedDropdownLabel");
      localStorage.removeItem("email");
      localStorage.removeItem("loginType");
      localStorage.removeItem("isSSOLogin");
      localStorage.removeItem("UUID");
      localStorage.removeItem("localId");
      history.push("/login");
    }
  };

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname === "/operationalreportslandingpage"
    ) {
      localStorage.setItem("selectedApp", "operational");
    } else if (
      history &&
      history.location &&
      history.location.pathname === "/homepage"
    ) {
      localStorage.setItem("selectedApp", "ucube");
    } else if (
      history &&
      history.location &&
      history.location.pathname === "/useraccess"
    ) {
      localStorage.setItem("selectedApp", "useraccess");
    }
  }, [history]);

  const getOperationalReportData = async () => {
    setLoading(true);
    try {
      const getIdToken = getCookie("idToken");
      if (selectedCountryCode) {
        const result = await MicroserviceFetchUtil.get(
          "ucube/operational-kpis/operationalReportsList",
          { customerToken: getIdToken, countryCode: selectedCountryCode }
        );
        console.log("resulttttttt", result);
        if (
          result &&
          result.statusCode === 200 &&
          result.statusMessage === "SUCCESS"
        ) {
          const opData = result["response-data"].operationalReportsList;
          if (opData.length > 0) {
            setOperationalReportsData(opData);
          } else {
            console.log("no data");
          }
        } else {
          console.error("API responded with error:", result);
        }
      }
    } catch (error) {
      console.error("Network or server error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (history.location.pathname === "/operationalreportslandingpage" ||
      history.location.pathname === "/reportpage") &&
      operationalReportsData &&
      !operationalReportsData.length &&
      getOperationalReportData();
  }, [history.location.pathname]);

  const onUcubeClick = () => {
    localStorage.setItem("selectedApp", "ucube");
    const location = {
      pathname: "/homepage",
    };
    history.replace(location);
    history.push({ state: { ucube: true } });
  };

  const onBackButtonClick = (clickedOn) => {
    GaEventHelper.gaCommonEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: clickedOn === "homeIcon" ? GA_EVENTS.select_home_icon : GA_EVENTS.go_back_navigation });
    localStorage.setItem("selectedApp", "ucube");
    const location = {
      pathname: "/landingscreen",
    };
    history.replace(location);
    history.push({ state: { ucube: true } });
  };

  const handleDropdownChange = (report) => {
    GaEventHelper.gaSelectReportEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: report.reportCategory === "transactionalreports" ? GA_EVENTS.select_transactional_report : GA_EVENTS.select_master_reports, reportType: report.reportCategory === "transactionalreports" ? GA_DATA_PARAMS.transactional_report_name : GA_DATA_PARAMS.master_report_name, reportName: report.reportName });
    history.replace({
      pathname: "/reportpage",
    });
    history.push({
      state: {
        reportName: report.reportName,
        reportCategory: report.reportCategory,
      },
    });
    setMenu(false);
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    if (
      history.location.pathname === "/operationalreportslandingpage" ||
      history.location.pathname === "/reportpage"
    ) {
      setReports(true);
    } else {
      setReports(false);
    }
  }, [history.location.pathname]);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpenReportDropdown("");
    }
  };

  const displayDTAccess = (dtData) => {
    const data = Array.isArray(dtData)
      ? dtData
      : typeof dtData === "string"
        ? dtData.split(",")
        : [];
    if (
      (userDetails.isSuperUser === "YES" || userDetails.isSuperUser === "NO") &&
      !dtAccess?.length
    )
      return "All";
    if (data.includes("All (Super Access)")) return "All";
    if (dtAccessToggle === "Hide" || data?.length <= 3) return data?.join(", ");
    return `${data?.slice(0, 3)?.join(", ")}...`;
  };
  return (
    <>
      <div className={styles.mainHeader}>
        <div className={styles.header}>
          <div className={styles.headertop}>
            <div className={styles.dttReports} onClick={() => onBackButtonClick("backArrow")}>
              <img src={common.logos.ucubeAiFrame} alt="" onClick={(e) => {
                e.stopPropagation();
                onBackButtonClick("homeIcon");
              }} />
            </div>
            <div className={menu ? styles.menuSide : styles.navlinks}>
              {/* {userDetails &&
                userDetails.accessToOperationalDashboards === "YES" && (
                  <div
                    onClick={onOperationalDashboardsClick}
                    className={styles.sideMenuOptions}
                  >
                    <img
                      src={landingHeader.opDashboardBlue}
                      className={styles.menuIcons}
                      alt=""
                    />
                    <p> Reports & Analytics Home</p>
                  </div>
                )} */}
              {history.location.pathname !== "/operationalreportslandingpage" &&
                history.location.pathname !== "/reportpage" && (
                  <>
                    {userDetails &&
                      userDetails.accessToUcube === "YES" &&
                      userDetails.role !== null && (
                        <div
                          onClick={onUcubeClick}
                          className={styles.sideMenuOptions}
                        >
                          <img
                            src={landingHeader.locate}
                            className={styles.menuIcons}
                            alt=""
                          />
                          <p> UCube Locate</p>
                        </div>
                      )}
                  </>
                )}
                {history.location.pathname !== "/operationalreportslandingpage" &&
                history.location.pathname !== "/reportpage" && (
                  <>
                    {userDetails &&
                      userDetails.accessToUcube === "YES" &&
                      userDetails.role !== null && (
                        <div
                          onClick={onUcubeClick}
                          className={styles.sideMenuOptions}
                        >
                          <img
                            src={landingHeader.fieldForce}
                            className={styles.menuIcons}
                            alt=""
                          />
                          <p> UCube Field Force</p>
                        </div>
                      )}
                  </>
                )}
              {isMobile &&
                reportTypes &&
                !loading &&
                reports &&
                reportTypes.map((reportType, index) => {
                  return superUser ||
                    reportType.value === "transactionalreports" ? (
                    <div
                      key={index}
                      onClick={() =>
                        setOpenReportDropdown(
                          openReportDropdown === reportType.value
                            ? ""
                            : reportType.value
                        )
                      }
                      className={
                        openReportDropdown === reportType.value
                          ? `${styles.dropdownMobile} ${styles.dropdownselected}`
                          : styles.dropdownMobile
                      }
                    >
                      <div className={styles.dropdownHeading}>
                        <div className={styles.dropdownHeadingName}>
                          <span>
                            <img
                              src={reportType.icon}
                              alt=""
                            />
                            {reportType.label}{" "}
                          </span>
                        </div>
                        <div className={styles.dropdownHeadingArrow}>
                          <img
                            src={common.arrows.rightArrowBlue}
                            color="white"
                            className={
                              openReportDropdown === reportType.value
                                ? styles.dropdownArrowOpen
                                : styles.dropdownArrowClose
                            }
                            alt=""
                          />
                        </div>
                      </div>
                      {openReportDropdown === reportType.value && (
                        <div className={styles.dropdownBody}>
                          {operationalReportsData
                            .filter(
                              (report) =>
                                report.reportCategory === reportType.value
                            )
                            .map((report, index) => (
                              <div
                                className={
                                  history.location.state?.reportName ===
                                    report.reportName
                                    ? `${styles.dropdownOptions} ${styles.dropdownSelected}`
                                    : styles.dropdownOptions
                                }
                                onClick={() => handleDropdownChange(report)}
                              >
                                <div className={styles["reportColumn__name"]}>
                                  {report.reportName}
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  ) : null;
                })}
              {!isMobile && <CountryDropdown />}
              {isMobile && (
                <div className={styles.SMOMobileView} onClick={logoutHandler}>
                  <img
                    src={landingHeader.logout}
                    className={styles.menuIcons}
                    alt="Logout"
                  />
                  <p>Logout</p>
                </div>
              )}
              <div className={styles.profileIcon} onClick={() => {
                GaEventHelper.gaProfileEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: GA_EVENTS.Profile_view, selectedBsa: selectedBsa })
              }}>
                <img
                  src={common.icons.profileIcon}
                  alt="Profileicon"
                  data-tooltip-id="profilePopup"
                />
              </div>
              <Tooltip
                className={styles.popupModal}
                id="profilePopup"
                place="bottom"
                openOnClick="true"
                offset="8"
                noArrow
                clickable
              >
                <div className={styles.popup}>
                  <div className={styles.popupDetails}>
                    <img className={styles.popupProfileIcon} src={landingHeader.user} alt="Profile" />
                    <div className={styles.profileText}>
                      <h4>{userDetails.name}</h4>
                      <p>{userDetails.email}</p>
                    </div>
                  </div>
                  {(isShadowUser || userDetails.accessToOperationalDashboards === "YES") && (
                  <div className={styles.userDetailsPopup}>
                  {isShadowUser && (
                    <>
                      <div className={styles.dtAccess}>
                        <p className={styles.title}>Role</p>
                        <p className={styles.display}>
                          {`Shadow User (${String(userDetails.role ?? "").toUpperCase()})`}
                        </p>
                      </div>
                      <div className={styles.dtAccess}>
                        <p className={styles.title}>Parent Email ID</p>
                        <p className={styles.display}>
                          {userDetails.parentEmailId ?? userDetails.parentEmail}
                        </p>
                      </div>
                    </>
                  )}
                  {userDetails.accessToOperationalDashboards === "YES" && (
                    <div className={styles.dtAccess}>
                      {" "}
                      <p className={styles.title}>DT Access: </p>
                      <p className={styles.display}>
                        {displayDTAccess(dtAccess)}
                      </p>
                      <p
                        className={styles.toggle}
                        onClick={() => {
                          setDTAccessToggle((prev) =>
                            prev === "All" ? "Hide" : "All"
                          );
                        }}
                      >
                        {dtAccess.length > 3 && dtAccessToggle}
                      </p>
                    </div>
                  )}
                  </div>
                  )}
                  <div onClick={logoutHandler} className={styles.popupLogout}>
                    <img src={landingHeader.logout} alt="" />
                    <p>Logout</p>
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className={menu ? styles.headerSidebar : (history.location.pathname === "/landingscreen" && !isMobile ? styles.hideHeaderBottom : styles.headerbottom)}>
          {!isMobile && (
            <div className={styles.dropdownConatiner}>
              {history &&
                history.location &&
                (history.location.pathname === "/operationalreportslandingpage" ||
                  history.location.pathname === "/reportpage") ? (
                <div
                  onClick={() => onBackButtonClick("homeIcon")}
                  className={
                    history &&
                      history.location.state &&
                      history.location.state.reportName
                      ? styles.backButton
                      : `${styles.backButton} ${styles.navLinkSelected}`
                  }
                >
                  <img src={landingHeader.locate} className={styles.menuIcons} alt="" />{" "}
                  <img src={landingHeader.home} className={styles.backArrow} alt="" />
                </div>
              ) : isAdminRoute(history.location.pathname) ? (
                <div className={styles.adminBreadcrumb}>
                  <span
                    onClick={() => {
                      history.push("/adminconfigurationpage");
                    }}
                    className={styles.adminConfigSpan}
                  >
                    Admin configuration
                  </span>
                  {ADMIN_ROUTE_LABELS[history.location.pathname] && (
                    <>
                      <span className={styles.adminBreadcrumbSeparator} aria-hidden="true">/</span>
                      <span className={styles.adminBreadcrumbCurrent}>
                        {ADMIN_ROUTE_LABELS[history.location.pathname]}
                      </span>
                    </>
                  )}
                </div>
              ) : (
                <></>
              )}
              <div className={styles.dropdownWrapper} ref={wrapperRef}>
                {reportTypes &&
                  (history.location.pathname ===
                    "/operationalreportslandingpage" ||
                    history.location.pathname === "/reportpage") &&
                  !loading &&
                  reportTypes.map((reportType, index) => {
                    return superUser ||
                      reportType.value === "transactionalreports" ? (
                      <div
                        key={index}
                        onClick={() =>
                          setOpenReportDropdown(
                            openReportDropdown === reportType.value
                              ? ""
                              : reportType.value
                          )
                        }
                        className={
                          openReportDropdown === reportType.value
                            ? `${styles.dropdown} ${styles.dropdownselected}`
                            : history &&
                              history.location &&
                              history.location.state &&
                              history.location.state.reportName &&
                              history.location.state.reportCategory ===
                              reportType.value
                              ? `${styles.dropdown} ${styles.navLinkSelected}`
                              : styles.dropdown
                        }
                      >
                        <span>
                          {reportType.label}{" "}
                          <img
                            src={common.arrows.dropdownArrow}
                            color="white"
                            className={styles.dropdownArrow}
                            alt=""
                          />
                        </span>
                        {openReportDropdown === reportType.value && (
                          <div className={styles.dropdownBody}>
                            {operationalReportsData
                              .filter(
                                (report) =>
                                  report.reportCategory === reportType.value
                              )
                              .map((report, index) => (
                                <div
                                  className={styles.dropdownOptions}
                                  onClick={() => handleDropdownChange(report)}
                                >
                                  <div className={styles["reportColumn__name"]}>
                                    {report.reportName}
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    ) : null;
                  })}
              </div>
            </div>
          )}
          {
            isMobile && (
              <div className={menu? styles.flexibleCol: styles.flexibleRow}>
                {
                  menu &&(
                    <>
                    <div className="flex-between">
                    <h4>{`Hello ${userDetails.name}`}</h4>
                    <img className={menu && styles.closebtn} src={menu ? landingHeader.closeIcon : landingHeader.hamMenu} alt="menu"  onClick={handleMenu}/>
                    </div>
                    <p>{userDetails.email}</p>
                    <p>{`Role: ${userDetails.role}`}</p>
                    <div className={styles.bsaRow}>
                    <span>Business Scope Assignment:</span>

                    {Object.keys(userDetails).length > 0 && (
                      <Select
                        options={userDetails?.bsa?.map((data) => ({ label: data, value: data }))}
                        onChange={(opt) => handleBsaChange(opt)}
                        isSearchable={false}
                        value={{
                          label: selectedBsa || userDetails?.bsa?.[0],
                          value: selectedBsa || userDetails?.bsa?.[0],
                        }}
                        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        classNames={{
                          container: () => styles.bsaSelectContainer,
                          control: () => styles.bsaSelectControl,
                          valueContainer: () => styles.bsaSelectValue,
                          singleValue: () => styles.bsaSelectText,
                          input: () => styles.bsaSelectInput,
                          indicatorsContainer: () => styles.bsaSelectIndicators,
                          indicatorSeparator: () => styles.seperator,
                          dropdownIndicator: () => styles.bsaSelectArrow,
                          menu: () => styles.bsaSelectMenu,
                          menuList: () => styles.bsaSelectMenuList,
                          option: () => styles.bsaSelectOption,
                        }}
                        data-testid="select"
                      />
                    )}
                  </div>
                      
                      </>
                  )
                }
                 
              <img className={menu && 'closebtn'} src={menu ? landingHeader.closeIcon : landingHeader.hamMenu} alt="menu"  onClick={handleMenu}/>
              {!menu && (
                <img
                  src={common.logos.ucubeAiFrame}
                  alt="UCube.Ai"
                  className={styles.mobileCenterLogo}
                  onClick={() => onBackButtonClick("homeIcon")}
                />
              )}
            <CountryDropdown isMobileView />

          </div>
            )
          }
        
         
        </div>
      </div>
      <div className={styles.mainHeaderSpacer} aria-hidden="true" />
    </>
  );
};

export default LandingHeader;
